
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppChatWrapper from "@/components/chat-components/ChatWrapper.vue";
import AppPublicLink from "@/components/PublicLink.vue";
import { Ticket, TICKET_STATUS_HANDLED, TICKET_STATUS_CLOSED } from "../../models/tickets/ticket";
import { ISelectItem } from "winfakt-vue-components";
import { TicketService } from "../../services/ticket-service";

export default Vue.extend({
	data() {
		return {
			publicLinkModal: false,
			publicLink: "",
		};
	},
	props: {
		ticket: {
			type: Object as () => Ticket,
			required: true
		},
		basePath: {
			type: String,
			default: "/support/tickets"
		}
	},
	computed: {
		isTicketHandled(): boolean {
			return this.ticket.statusId == TICKET_STATUS_HANDLED;
		},
		isTicketClosed(): boolean {
			return this.ticket.statusId == TICKET_STATUS_CLOSED;
		},
		buttonBarItems(): ISelectItem<string>[] {
			return [
				{text: this.$ct("archive-ticket").toString(), value: "archiveTicket", icon: "archive"},
				//{text: this.$ct("delete-ticket").toString(), value: "deleteTicket", icon: "trash-alt"},
				{text: this.$ct("create-public-url").toString(), value: "shareTicket", icon: "share-square"}
			];
		},
	},
	methods: {
		onFiles(files: File[]) {
			this.$emit("files", files);
		},
		async archiveTicket() {
			await TicketService.archiveTicket(this.ticket.id);
			this.$wf.notify(this.$ct("archive-succes").toString(), "success", 3000, "check");
		},
		async deleteTicket() {
			let confirm = await this.$wf.confirm(this.$ct("delete-confirm"), this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.info"), "info");
			if (confirm) {
				await TicketService.deleteTicket(this.ticket.id);
				this.$wf.notify(this.$ct("delete-succes").toString(), "success", 3000, "check");
				this.$emit("update");
				this.$router.push(this.basePath);
			}
		},
		async shareTicket() {
			this.publicLinkModal = true;
			this.publicLink = await TicketService.generateTicketUrl(this.ticket.id);
		},
		async openTicket() {
			await TicketService.openTicket(this.ticket.id);
		},
		async closeTicket() {
			await TicketService.closeTicket(this.ticket.id);
		},
		trigger(value: string) {
			(this as any)[value]();
		},
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppChatWrapper,
		AppPublicLink
	},
	i18nEx: {
		componentPrefix: "components.tickets"
	}
});
